var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quick-reply-container" },
    [
      _c(
        "div",
        { staticClass: "quick-reply-level1" },
        _vm._l(_vm.templates, function(item) {
          return _c(
            "span",
            {
              key: item.code,
              staticClass: "quick-reply-tag-wrapper",
              on: {
                click: function($event) {
                  return _vm.handleLevel1Click(item)
                }
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: item.title,
                    placement: "top",
                    "open-delay": 500
                  }
                },
                [
                  _c(
                    "el-tag",
                    {
                      staticClass: "tag-green",
                      class: {
                        "tag-expandable": _vm.hasMultipleChildren(item),
                        "tag-expanded":
                          _vm.expandedCode === item.code &&
                          _vm.hasMultipleChildren(item),
                        "tag-child": _vm.hasSingleChild(item)
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(item.title) + "\n          "
                      ),
                      _vm.hasMultipleChildren(item)
                        ? _c("i", {
                            staticClass: "el-icon-arrow-down quick-reply-arrow",
                            class: {
                              "arrow-up": _vm.expandedCode === item.code
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "accordion" } }, [
        _vm.expandedItem
          ? _c(
              "div",
              {
                key: _vm.expandedItem.code,
                staticClass: "quick-reply-children"
              },
              _vm._l(_vm.expandedItem.children, function(child) {
                return _c(
                  "span",
                  {
                    key: child.code,
                    staticClass: "quick-reply-tag-wrapper",
                    on: {
                      click: function($event) {
                        return _vm.$emit("select", child.content)
                      }
                    }
                  },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: child.title,
                          placement: "top",
                          "open-delay": 500
                        }
                      },
                      [
                        _c("el-tag", { staticClass: "tag-green tag-child" }, [
                          _vm._v(_vm._s(child.title))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06475dae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06475dae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MassageSuggest.vue
// module id = null
// module chunks = 